@let color = ColorHelper.getInformationRowColor(expirationDate());
<onyx-information-row [label]="label()" [color]="color" [size]="size()">
  {{ expirationDate() | onyxDate: 'date-dot' }}

  <ng-container icon>
    @if (['yellow', 'red'].includes(color)) {
      <onyx-icon
        id="document-expiration-issue"
        [class]="color"
        name="error-neutral-filled"
        [size]="16"
      ></onyx-icon>
    }
  </ng-container>

  <ng-content></ng-content>
</onyx-information-row>
